import { createDescriptorIfPrivate } from '@ff-os/shared-utils/private-urls';
import { urls } from '@ff-os/shared-utils/urls';
import { PhotoPrintsJson } from 'plugins/scenes/photo-prints/shared/src/PhotoPrintsJson';

export const toPhotoUrl = (photo: PhotoPrintsJson.Photo, jwt: string | null) => {
    if (photo.assetSource === 'private') {
        const url = urls.privateAssetUrl(photo.assetId);
        return createDescriptorIfPrivate(url, jwt);
    } else if (photo.assetSource === 'public') {
        return urls.publicAssetUrl(photo.assetId);
    } else if (photo.processed) {
        return photo.localUrl;
    } else {
        return undefined;
    }
};